import { getFolder } from "../api/folder.services.ts"
import type { FolderParent } from "../types/folder.types.ts"
import type { FolderAncestry } from "./folder-path.ts"

const MAX_DEPTH = 8

// One request per level: `Folder.parent` carries only the immediate parent.
export const resolveFolderAncestry = async (folderId: string): Promise<FolderAncestry> => {
  const ancestors: FolderParent[] = []
  let currentId: string | null = folderId

  for (let i = 0; i < MAX_DEPTH && currentId; i++) {
    const response = await getFolder(currentId)
    if (!response.ok || !response.data) break
    ancestors.unshift({ id: response.data.id, name: response.data.name })
    currentId = response.data.parent?.id ?? null
  }

  return { ancestors, isComplete: currentId === null }
}

export const resolveFolderBreadcrumb = async (folderId: string): Promise<FolderParent[]> =>
  (await resolveFolderAncestry(folderId)).ancestors
